module.exports = __webpack_public_path__ + "img/4.2ae28b8.png";